import { render } from "./ChevronRightButton.vue?vue&type=template&id=099fdf41"
import script from "./ChevronRightButton.vue?vue&type=script&lang=js"
export * from "./ChevronRightButton.vue?vue&type=script&lang=js"
script.render = render

export default script